import { Watch } from "lucide-react";

export function ConnectorsCard() {
  return (
    <section className="card p-5 mt-4" data-testid="connectors-card">
      <div className="eyebrow mb-3">Connected devices</div>
      <div className="flex items-center gap-3">
        <span className="h-10 w-10 rounded-full bg-[#F5F2EC] grid place-items-center"><Watch className="h-[18px] w-[18px] text-[#6E8B74]" strokeWidth={1.75} /></span>
        <div className="flex-1"><div className="font-medium">Oura Ring</div><div className="text-xs text-stone-500">Fill in sleep and activity automatically</div></div>
        <span data-testid="oura-coming-soon" className="text-[11px] font-semibold px-3 py-1 rounded-full bg-[#EFECE6] text-stone-600">Coming soon</span>
      </div>
    </section>
  );
}
